export default "__VITE_ASSET__8e232645__"